import { render } from "./ShippingDetails.vue?vue&type=template&id=14acf3b1"
import script from "./ShippingDetails.vue?vue&type=script&lang=js"
export * from "./ShippingDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__